import * as $ from "jquery"
import { Swiper, SwiperOptions, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

const init = ()=> {
    
    let pagination = 'js-pagination-slider';
    let activePage = 'js-pagination-active'
    
    if($(pagination).length > 0){
        console.log($(pagination).length);
    }

    const swiperOptions = (next: string,prev: string, slideNumber: number = 1, currentIndex: number = 0) => {
        Swiper.use([Navigation])
        const swiperParams: SwiperOptions = {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 3,
            initialSlide: currentIndex,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        };
        return swiperParams
    }

    const createSlider = () => {
            const slideNumber = 5;
            const currentIndex = parseInt($(`.${activePage}`).attr('data-current-page')) -1
            const swiper = new Swiper(`.${pagination}`, swiperOptions(`.${pagination}--right`,`.${pagination}--left`, slideNumber, currentIndex));
        
    }
    setTimeout(()=>{ 
        createSlider();
    }, 100);
	
}




export const pagination = {
	init: init
};